import he from 'he'
import {
  getAboutNh as getAboutNhAPI,
  getWhatToDo,
  getFlashNews as getFlashNewsAPI,
  getAboutMembership as getAboutMembershipAPI
} from '../api/support'
import {
  setAboutMembership,
  setAboutNH,
  setFlashNews,
  setWhatToDos
} from '../state/slices/support_slice'
import { useAppDispatch } from './state'

export const useSupport = () => {
  const dispatch = useAppDispatch()

  const getAboutMembership = async () => {
    try {
      const result = await getAboutMembershipAPI()

      if (result.data) {
        result.data.aboutPreference.content = he.decode(result.data.aboutPreference.content)

        dispatch(setAboutMembership(result.data.aboutPreference.content))
      }

      return true
    } catch (error) {
      return false
    }
  }

  const getAboutNH = async () => {
    try {
      const result = await getAboutNhAPI()

      if (result.data) {
        result.data.aboutInsurance.content = he.decode(result.data.aboutInsurance.content)

        dispatch(setAboutNH(result.data.aboutInsurance))
      }

      return true
    } catch (error) {
      return false
    }
  }

  const getWhatToDos = async () => {
    try {
      const result = await getWhatToDo()

      if (result.data) {
        result.data.myAppContents.forEach(content => {
          content.content = he.decode(content.content)
        })
        dispatch(setWhatToDos(result.data.myAppContents))
      }

      return true
    } catch (error) {
      return false
    }
  }

  const getFlashNews = async () => {
    try {
      const result = await getFlashNewsAPI()

      if (result.data && result.data.flashMessages.length > 0) {
        result.data.flashMessages.map((news) => {
          if (news.content) {
            news.content = he.decode(news.content)
          }

          return news
        })

        dispatch(setFlashNews(result.data.flashMessages[0]))
      } else {
        dispatch(setFlashNews(undefined))
      }

      return true
    } catch (error) {
      dispatch(setFlashNews(undefined))

      return false
    }
  }

  return {
    getAboutMembership,
    getAboutNH,
    getWhatToDos,
    getFlashNews
  }
}

export default useSupport
